import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";

export const isCountryUSA = (country: string | undefined): boolean =>
  country === THREE_LETTER_PRIMARY_COUNTRY_CODES.USA;
